
























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { OtherActivities, WeeklyMeeting, CoreTeamMeeting, MinistryMeeting } from '../common/form-type.interface';

import util from '../common/utility';

@Component({})
export default class extends Vue {
    @Prop() public weeklyMeeting: WeeklyMeeting | any;
    @Prop() public coreTeamMeeting: CoreTeamMeeting | any;
    @Prop() public otherMinistryMeeting: MinistryMeeting | any;
    @Prop() public discipleshipCellMeeting: MinistryMeeting | any;
    @Prop() public otherActivities: OtherActivities | any;

    public previewData() {
        this.$router.push('preview-meeting-data');
    }

    public saveData(data: any) {
        util.eventBus.$emit('data', { type: 'otherActivities', data });
    }

    get disableSubmit() {
        return (
            !this.weeklyMeeting.isValid ||
            !this.coreTeamMeeting.isValid ||
            !this.discipleshipCellMeeting.isValid ||
            !this.otherMinistryMeeting.isValid
        );
    }
}
